export default __webpack_public_path__ + "static/media/KEN.089bf6b3.svg";